import { Component, OnInit, Input, HostListener, AfterViewInit, Directive, OnDestroy, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { tPaymentService } from 'src/app/services/tPayment.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tPaymentModel } from 'src/app/models/tPaymentModel';
import { tBillPayModel, BillPay_ItemType } from 'src/app/models/tBillPayModel';
import { AppCurrencyPipe } from 'src/app/services/CommonService/custom.currency.pipe';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { HTTP_ResultModel } from 'src/app/models/non-master-model/HTTP_ResultModel';
import { SpecialPaymentMethod } from 'src/app/models/non-master-model/SpecialPaymentMethod';
import { BillPayPaymentMethod_ehCardDialogService } from 'src/app/services/Non-Master/BillPayPaymentMethod_ehCardDialog.service';
import { BillPayPayment_Package_totalAmountService } from 'src/app/services/Non-Master/BillPayPayment_Package_totalAmount.service';

import { decimalplaceHandler } from 'src/app/services/Non-Master/decimalplaceHandler.service';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { TranslateService } from '@ngx-translate/core';
import { BillPayPrescriptionUpdateDialogService } from 'src/app/services/Non-Master/BillPayPrescriptionUpdateDialog.service';
import { fromEvent,  Subscription } from 'rxjs';
import { mergeMap, takeUntil, tap } from 'rxjs/operators';
import { get } from 'http';

interface Point {x: number, y: number};

// @Directive({
//   selector: '.modal-header'
// })

@Component({
  selector: 'app-bill-payment-dialog',
  templateUrl: './bill-payment-dialog.component.html',
  styleUrls: ['./bill-payment-dialog.component.css']
})


export class BillPaymentDialogComponent implements OnInit,AfterViewInit, OnDestroy {

  TAG = 'BillPaymentDialogComponent';
  dataList_item: tBillPayModel[];
  dataList_Payment: tBillPayModel[];
  @Input() invoiceID: string;
  @ViewChild('input_payAmount') input_payAmount;

  editForm: FormGroup;
  submitted = false;
  formValidSuccessSubmitted = false;

  paymentMethodList: tPaymentModel[] = new Array;

  subscription: Subscription;

  start: Point;
  offset: Point = {x: 0, y: 0};


  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private apiResultHandlerService: ApiResultHandlerService,
    private tPaymentService: tPaymentService,
    private tBillPayService: tBillPayService,
    private billPayPaymentMethod_ehCardDialogService: BillPayPaymentMethod_ehCardDialogService,
    private billPayPayment_Package_totalAmountService: BillPayPayment_Package_totalAmountService,
    private billPayPrescriptionUpdateDialogService: BillPayPrescriptionUpdateDialogService,

    private decimalplaceHandler: decimalplaceHandler,

    private apiResultDialogService: ApiResultDialogService,
    private translate: TranslateService,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    const currentLanguage = localStorage.getItem('currentLanguage');
    translate.use(currentLanguage);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      // this.makeItDraggable();
    });
  }
  ngOnDestroy(): void {
    if (this.subscription)
    this.subscription.unsubscribe();
  }

  clickFocusInput_payAmount() {
    this.input_payAmount.nativeElement.select();
  }

  private makeItDraggable() {

    const modalDialogElement = this.el.nativeElement.closest(".modal-dialog");

    if (!modalDialogElement) {
      console.error('DragModalDirective cannot find the parent element with class modal-dialog')
      return;
    }

    this.renderer.setStyle(this.el.nativeElement, 'user-select', 'none');
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'move');

    this.renderer.setStyle(modalDialogElement, 'transition', 'none');

    const down$ = fromEvent(this.el.nativeElement, 'mousedown')
    const move$ = fromEvent(document, 'mousemove');
    const up$ = fromEvent(document, 'mouseup')

    const drag$ = down$.pipe(
      tap(($event: MouseEvent) => {
        this.start = {
          x: $event.clientX - this.offset.x,
          y: $event.clientY - this.offset.y
        };
      }),
      mergeMap(down => move$.pipe(
        takeUntil(up$)
      ))
    );

    this.subscription = drag$.subscribe(($event: MouseEvent) => {
      this.offset = {
        x: $event.clientX - this.start.x,
        y: $event.clientY - this.start.y
      }

     this.renderer.setStyle(modalDialogElement, 'transform', `translate(${this.offset.x}px, ${this.offset.y}px)`);
    }) }



  // UI
  arAmount: number;
  billRemaining: number;

  successReturnMsg: any;

  ngOnInit() {
    this.editForm = this.formBuilder.group({

      bpArAmount: [],
      paymentWay: [this.paymentMethodList, [Validators.required]],
      payAmount: ['', [Validators.required]],
      billRemaining: [this.billRemaining],
      bpRemark: []

    });

    this.getAllData();
  }

  getAllData(): void {
    //   this.log.i(this.TAG, 'getAllData ');
    // this.getItemTypeInfo();

    var shopID = NavigationComponent.selectedShopID.toString();

    this.tBillPayService.getDataByShopIDAndVoucherID(shopID, this.invoiceID).subscribe(data => {

      this.dataList_item = new Array;
      this.dataList_Payment = new Array;
      for (var i = 0; i < data.length; i++) {

        var itemType = data[i].bpItemType;
        if (itemType == BillPay_ItemType.ITEM || itemType == BillPay_ItemType.ITEM_PACKAGE || itemType == BillPay_ItemType.PRESCRIPTION) {
          this.log.i(this.TAG, "id = " + data[i].id + " , itemType = " + data[i].bpItemType + " , item desc = " + data[i].bpItemDesc);

          this.dataList_item.push(data[i]);


        } else if (itemType == BillPay_ItemType.PAYMENT || itemType == BillPay_ItemType.PAYMENT_VOID || itemType == BillPay_ItemType.PAYMENT_VOID_PACKAGE) {
          this.dataList_Payment.push(data[i]);
        }
      }

      const totalArAmount = data.reduce((total, item) => {
        return total + item.bpArAmount;
      }, 0);

      console.log('totalArAmount :',totalArAmount);

      this.getConsultStatus().subscribe((r) => {
        if (r.clthBillingStatus == "Completed") this.activeModal.close();
      });

      // if(totalArAmount < 1) return this.activeModal.close();
      //if BI is completed , close
      this.UpdateDialogValue();

    });

    this.getPaymentMethod();
    this.updateRemainer();
  }

  getConsultStatus() {
    return this.tBillPayService
      .getCTStatus(this.invoiceID)
  }

  UpdateDialogValue() {
    this.arAmount = 0;
    // this.log.i(this.TAG, "starting arAmount = " + this.arAmount);

    for (var i = 0; i < this.dataList_item.length; i++) {
      // this.log.i(this.TAG, "last arAmount = " + this.arAmount);
      this.arAmount += Number.parseFloat(this.dataList_item[i].bpArAmount.toString());

      // this.log.i(this.TAG, "looping arAmount = " + Number.parseFloat(this.dataList_item[i].bpArAmount.toString()));
      // this.log.i(this.TAG, "end arAmount = " + this.arAmount);

    }

    for (var p = 0; p < this.dataList_Payment.length; p++) {
      if (this.dataList_Payment[p].bpArAmount != null && this.dataList_Payment[p].bpArAmount != undefined && this.dataList_Payment[p].bpArAmount.toString() != '') {
        this.arAmount += Number.parseFloat(this.dataList_Payment[p].bpArAmount.toString());

      }


    }

    // this.log.i(this.TAG, "UpdateDialogValue arAmount = " + this.arAmount);

    (<FormControl>this.editForm.controls['bpArAmount']).setValue(this.displayTotalAmt(this.arAmount));
    (<FormControl>this.editForm.controls['payAmount']).setValue(this.displayTotalAmt(this.arAmount));


    // this.log.i(this.TAG,"arAmount = "+ this.arAmount);

    //prevent amount <= 0 call payment
    // if (this.arAmount <= 0) {
    //   this.activeModal.close();
    // }

    // (<FormControl>this.editForm.controls['bpArAmount']).setValue(this.arAmount.toFixed(ToFixRange.BillingPayment));
  }

  getPaymentMethod() {
    this.log.i(this.TAG, "do getPaymentMethod");
    var shopID = NavigationComponent.selectedShopID.toString();

    this.tPaymentService.getActiveData(shopID).subscribe(data => {
      this.paymentMethodList = data;
      //  this.editForm.get('paymentWay').setValue(this.paymentMethodList[0].paymentID);
    });
  }

  updateRemainer() {
    //update remainer
    var arAmountInput = this.editForm.get('bpArAmount').value;
    var payAmountInput = this.editForm.get('payAmount').value;

    (<FormControl>this.editForm.controls['billRemaining']).setValue(this.displayTotalAmt(arAmountInput - payAmountInput));

  }

  changePayAmount(inputValue: number) {
    this.log.d(this.TAG, "do changePayAmount inputValue = " + inputValue + " , new value = " + (this.arAmount - inputValue));
    // this.UpdateDialogValue();


    (<FormControl>this.editForm.controls['billRemaining']).setValue(this.displayTotalAmt(this.arAmount - inputValue));
    // (<FormControl>this.editForm.controls['billRemaining']).setValue((this.arAmount - inputValue).toFixed(ToFixRange.BillingPayment));
  }


  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }


  get f() { return this.editForm.controls; }

  confirm() {

    let responseMessage = '';
    this.translate.get('alert_pay_payAmount_exceed_bpArAmount').subscribe(x=>responseMessage=x);

    console.log('confirm()')
    console.log('payAmount = '+this.editForm.get('payAmount').value)
    console.log('bpArAmount = '+this.editForm.get('bpArAmount').value)
    // if (this.editForm.get('payAmount').value > this.editForm.get('bpArAmount').value)
    // {
    //   alert(responseMessage);
    //   return;
    // }

    var specialPaymentType = 0;
    for (var i = 0; i < this.paymentMethodList.length; i++) {
      if (this.editForm.get('paymentWay').value == this.paymentMethodList[i].paymentID) {
        specialPaymentType = this.paymentMethodList[i].specialPaymentType;
        break;
      }
    }

    //this.log.i(this.TAG, "do confirm paymentWay value = " + this.editForm.get('paymentWay').value + " , specialPaymentType = " + specialPaymentType);



    // // if it is HealthCare
    if (specialPaymentType == 2) {
      // open dialog to input data
      this.log.i(this.TAG, "open ecCardDialog");

      this.billPayPaymentMethod_ehCardDialogService.openDialog().result.then(
        (result) => {

          var ehCardConfirmedVoucher = JSON.parse(result).ehCardConfirmedID;
          this.log.i(this.TAG, "ehCardDialog voucherID = " + ehCardConfirmedVoucher);
          this.submitData(ehCardConfirmedVoucher);


        }, (reason) => {
          this.log.i(this.TAG, "ehCardDialog cancel reason = " + reason);

        });


    } else {
      this.submitData(null);
    }



  }

  selectPackage_ReductTotalAmount() {
    this.log.i(this.TAG, "do selectPackage_ReductTotalAmount " + this.editForm.get('payAmount').value);

    this.billPayPayment_Package_totalAmountService.openDialog(this.dataList_item[0].bpPatientID, this.dataList_item[0].bpInvoiceNumber, this.editForm.get('payAmount').value).result.then(
      (result) => {

        // var ehCardConfirmedVoucher = JSON.parse(result).ehCardConfirmedID;
        // this.log.i(this.TAG, "ehCardDialog voucherID = " + ehCardConfirmedVoucher);
        // this.submitData(ehCardConfirmedVoucher);
        this.activeModal.close(result);

      }, (reason) => {
        this.log.i(this.TAG, "ehCardDialog cancel reason = " + reason);

      });

  }

  displayTotalAmt(amt: number) {
    return this.decimalplaceHandler.convertToValueStr(amt, decimalplaceHandler.dpTotalAmt, decimalplaceHandler.round_TotalAmt);
  }


  submitData(ehCardVoucher: string) {
    console.log('submitData()')
    this.submitted = true;
    if (this.editForm.valid) {
      console.log('submit valid');
      this.formValidSuccessSubmitted =true;
      //
      var shopID: string = NavigationComponent.selectedShopID.toString();
      var bpInvoiceNumber: string = this.dataList_item[0].bpInvoiceNumber;
      var bpLineNumber: number = 1;
      var bpPaymentNumber: string = this.editForm.get('paymentWay').value;
      var bpDateTime: Date = null;
      var bpPatientID: string = this.dataList_item[0].bpPatientID;
      var bpChangeID: string = this.dataList_item[0].bpChangeID;
      var bpConsultNumber: string = null;
      var bpItemID: string = null;
      var bpItemType: string = BillPay_ItemType.PAYMENT;
      var bpItemDesc: string = null;
      var bpQty: number = null;
      var bpStandardPrice: number = null;

      var bpFinalPrice: number = null;
      var bpLineAmount: number = null;

      var bpArAmount: number = this.editForm.get('payAmount').value;
      var bpPackInvoiceNo: string = null;
      var bpPackItemID: string = null;
      var bpPackageQty: number = null;
      var bpPackFaceAmt: number = null;
      var bpEmployeeID: string = null;
      var bpPrintName: string = null;
      var bpPaymentMethodID: string = this.editForm.get('paymentWay').value;

      var paymentName: string = null;
      for (var i = 0; i < this.paymentMethodList.length; i++) {
        if (bpPaymentMethodID == this.paymentMethodList[i].paymentID) {
          paymentName = this.paymentMethodList[i].paymentName;
        }
      }

      var bpPaymentMethodName: string = paymentName;
      var bpRemark: string = null;
      var bpPaymentRemark: string = this.editForm.get('bpRemark').value;

      var inActive: string = "N";
      var lastModifyDatetime: Date = null;
      var lastModifyUserID: string = NavigationComponent.userID;


      var newBillPay = new tBillPayModel();
      newBillPay.shopID = shopID;
      newBillPay.bpInvoiceNumber = bpInvoiceNumber;
      newBillPay.bpLineNumber = bpLineNumber;
      newBillPay.bpPaymentNumber = bpPaymentNumber;
      newBillPay.bpDateTime = bpDateTime;
      newBillPay.bpPatientID = bpPatientID;
      newBillPay.bpChangeID = bpChangeID;
      newBillPay.bpConsultNumber = bpConsultNumber;
      newBillPay.bpItemID = bpItemID;
      newBillPay.bpItemType = bpItemType;
      newBillPay.bpItemDesc = bpItemDesc;
      newBillPay.bpQty = bpQty;
      newBillPay.bpStandardPrice = bpStandardPrice;
      newBillPay.bpFinalPrice = bpFinalPrice;
      newBillPay.bpLineAmount = bpLineAmount;
      newBillPay.bpArAmount = bpArAmount * -1;
      newBillPay.bpPackInvoiceNo = bpPackInvoiceNo;
      newBillPay.bpPackItemID = bpPackItemID;
      newBillPay.bpPackageQty = bpPackageQty;
      newBillPay.bpPackFaceAmt = bpPackFaceAmt;
      newBillPay.bpEmployeeID = bpEmployeeID;
      newBillPay.bpPrintName = bpPrintName;
      newBillPay.bpPaymentMethodID = bpPaymentMethodID;
      newBillPay.bpPaymentMethodName = bpPaymentMethodName;
      newBillPay.bpRemark = bpRemark;
      newBillPay.bpPaymentRemark = bpPaymentRemark;
      newBillPay.inActive = inActive;
      newBillPay.ehVoucher = ehCardVoucher;
      newBillPay.lastModifyDatetime = lastModifyDatetime;
      newBillPay.lastModifyUserID = lastModifyUserID;


      // var paymentList: tBillPayModel[] = new Array;
      // paymentList.push(newBillPay);

      this.log.i(this.TAG, "paymentList newBillPay = " + JSON.stringify(newBillPay));

      //input must > 0
      // if (bpArAmount > 0) {
        this.tBillPayService.addData(newBillPay).subscribe(

          (data: any) => {

            this.log.i(this.TAG, 'onSubmit success');
            let returnDisplayMsg = '';


            if (data.statusCode === StatusMessage.Status_BadRequest) {
              console.log(data);
              if(data.custStatusCode && data.custStatusCode == "ERORR_PAY_PRESCRIPTION_MISSING"){
                let msg = "";
                this.translate.get('ERORR_PAY_PRESCRIPTION_MISSING').subscribe(x=>msg=x);
                this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, msg);
              }else{
                this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, '已有完成付款記錄, 不作付款');
              }
            }else if (data.statusCode === StatusMessage.Status_BillPay_Prescription_Price_NotMatch){
              this.translate.get('Message_BillPay_Prescription_Price_NotMatch').subscribe((res: string) => {
                returnDisplayMsg = res;
              });

            //  this.billPayPrescriptionUpdateDialogService.openDialog(returnDisplayMsg,this.dataList_item);


              this.billPayPrescriptionUpdateDialogService.openDialog(returnDisplayMsg,this.dataList_item,this.invoiceID).result.then((result:tBillPayModel) => {
                this.log.i(this.TAG, 'billPayPrescriptionUpdateDialogService data = ' + result.id);
                this.activeModal.dismiss('Cross click')


              }, (reason) => {
                this.log.i(this.TAG, 'billPayPrescriptionUpdateDialogService reason = ' + reason);
                this.activeModal.dismiss('Cross click')

              });

              // this.apiResultDialogService.openDialog(
              //   MastersKeyStringValue.ACTION_MessageDialog, AppSettings.Path_prescription, MastersKeyStringValue.STATUS_FAIL, returnDisplayMsg);

            //  this.activeModal.dismiss('Cross click')

            }



            //if finish all payment close, else keep here
            this.formValidSuccessSubmitted = false;

            this.getAllData();



            //  this.activeModal.close(data);
            this.log.i(this.TAG, "do confirm data = " + JSON.stringify(data));

          },
          err => {
            this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));

            this.apiResultHandlerService.ErrHandler();

          });

      // }



    } else {

      this.formValidSuccessSubmitted = false;

      var payAmountInput = this.editForm.get('payAmount').value;
      var paymentWayInput = this.editForm.get('paymentWay').value;


      this.log.i(this.TAG, "this.editForm.valid = false , payAmountInput = "+payAmountInput);

      if (payAmountInput == '' || payAmountInput == null || payAmountInput == undefined) {
        alert("未輸入: 付款金額");
      } else if (paymentWayInput == '') {
        alert("未輸入: 付款方法");

      }



    }


  }

  openAPI_Result_Model(status, msg) {
    this.log.i(this.TAG, 'openConfirmModal action = ' + status);

    return this.apiResultDialogService.openDialog(status, '', status, msg);
  }



}
